import i18n from '../../../i18n'
import {
  ACTION_GET_VISIT_TYPES,
  ACTION_GET_DEFAULT_INSTITUTION,
  ACTION_GET_VISIT_TIMES,
  ACTION_BOOK_APPOINTMENT,
  SET_VISIT_TYPE_LIST,
  SET_VISIT_TIME_LIST,
  SET_INSTITUTION,
  SET_BOOK_RESULT,
} from '../../types/appointment.types'
import { ACTION_SET_ALERT } from '../../types/alerts.types'
import {
  getVisitTypes, getInstitutionsInRange, getVisitTimes, bookAppointment,
} from '../../../api/appointment'

export default {
  [ACTION_GET_VISIT_TYPES]: ({ commit, dispatch }) => {
    getVisitTypes()
      .then((result) => {
        commit(SET_VISIT_TYPE_LIST, result.data.appointmentTypes)
      })
      .catch((error) => {
        console.log(error)
        const alert = { type: 'error', message: i18n.t('alerts.getVisitTypesError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
  [ACTION_GET_DEFAULT_INSTITUTION]: ({ commit }) => {
    const data = { latitude: 50.271404, longitude: 19.004501, rangeInKm: 1 }
    getInstitutionsInRange(data)
      .then((result) => {
        commit(SET_INSTITUTION, result.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  [ACTION_GET_VISIT_TIMES]: ({ commit, dispatch }, payload) => {
    getVisitTimes({ ...payload })
      .then((result) => {
        commit(SET_VISIT_TIME_LIST, result.data)
      })
      .catch((error) => {
        console.log(error)
        const alert = { type: 'error', message: i18n.t('alerts.getVisitTimesError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
  [ACTION_BOOK_APPOINTMENT]: ({ commit, dispatch }, payload) => {
    bookAppointment({ ...payload })
      .then((result) => {
        commit(SET_BOOK_RESULT, result.data)
      })
      .catch((error) => {
        console.log(error)
        const alert = { type: 'error', message: i18n.t('alerts.bookAppointmentError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
}
